import React, { FC } from 'react';
import './SwitchText.scss';

export enum SwitchStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

interface ISwitchText {
  status: SwitchStatus;
  handleChangeStatus: (e: React.ChangeEvent<HTMLInputElement> | boolean) => void;
  activeLabel?: string;
  inactiveLabel?: string;
  isDisabled?: boolean;
}

export const SwitchText: FC<ISwitchText> = ({
  status,
  handleChangeStatus,
  activeLabel = SwitchStatus.ACTIVE,
  inactiveLabel = SwitchStatus.INACTIVE,
  isDisabled = false
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (isDisabled) return;
    event.preventDefault();
    handleChangeStatus(status === SwitchStatus.INACTIVE);
  };

  return (
    <div
      className={`switchText ${status === SwitchStatus.INACTIVE ? SwitchStatus.INACTIVE : SwitchStatus.ACTIVE} ${isDisabled ? 'disabled' : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      onKeyPress={e => {
        if (isDisabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick(e as any);
        }
      }}
    >
      <div className={`switchBall ${status === SwitchStatus.ACTIVE ? SwitchStatus.ACTIVE : SwitchStatus.INACTIVE}`} />

      <div className={`titleSwitch ${status === SwitchStatus.ACTIVE ? SwitchStatus.ACTIVE : SwitchStatus.INACTIVE}`}>
        {status === SwitchStatus.ACTIVE ? activeLabel : inactiveLabel}
      </div>
    </div>
  );
};
